import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { GM_STARTING_MESSAGE } from './gmLease';
import { COLOR } from './ui/tokens';

/**
 * Game-server state for manual play (from useGmLease): "Starting game…" while
 * the gateway starts the game's GM, or the reason it could not be started.
 */
export default function GmLeaseNotice({ lease, color = COLOR.text }) {
    if (!lease) return null;
    if (lease.status === 'starting') {
        return (
            <Box data-testid="gm-lease-notice" role="status"
                sx={{ mt: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                <CircularProgress size={16} sx={{ color }} />
                <Typography variant="body2" sx={{ color }}>{GM_STARTING_MESSAGE}</Typography>
            </Box>
        );
    }
    if (lease.status === 'error' && lease.error) {
        return (
            <Box data-testid="gm-lease-notice" role="alert" sx={{ mt: 2, textAlign: 'center' }}>
                <Typography variant="body2" sx={{ color: '#f87171' }}>{lease.error}</Typography>
            </Box>
        );
    }
    return null;
}
